import { render, staticRenderFns } from "./TitleOnlyCard.vue?vue&type=template&id=5f44d259&scoped=true&"
import script from "./TitleOnlyCard.vue?vue&type=script&lang=js&"
export * from "./TitleOnlyCard.vue?vue&type=script&lang=js&"
import style0 from "./TitleOnlyCard.vue?vue&type=style&index=0&id=5f44d259&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f44d259",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSelect,VSimpleTable})
